
    import '/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.en.md?watch=parent';
    export const demoIndex = {
  ids: ["flowdiagram-demo-common","flowdiagram-demo-markdown"],
  getter: () => import(/* webpackChunkName: "meta__FlowDiagram__en" */'/home/runner/work/GPT-Vis/GPT-Vis/src/FlowDiagram/index.en.md?type=demo')
};